import Glide from '@glidejs/glide/dist/glide';

export class AwsPage{

  _awsWrapperEl;
  _sliderEl;
  _glide;

  init() {
    this._awsWrapperEl = document.querySelector('.aws-page-wrapper');

    if (this._awsWrapperEl) {
      this.initAppSlider();
      this.initHeaderAnimation();
    }
  }

  initAppSlider() {
    window.addEventListener('load', () => {

      this._sliderEl = this._awsWrapperEl.querySelector('.aws-page-wrapper__slider-section__slider');

      window.addEventListener('load', () => {

      })
      if (this._sliderEl) {

        this._glide = new Glide(this._sliderEl, {
          type: 'carousel',
          autoplay: 5000,
          perView: 1,
          gap: 75,
          startAt: 1,
          animationDuration: 1000,
          peek: {
            before: '0px',
            after: '0px'
          },
          hoverpause: false,
          keyboard: false,
        }).mount();
      }
    });

  }


  initHeaderAnimation() {
    const image = document.body.querySelector('#header-image');
    const images = document.body.querySelectorAll('.glide__slide--clone img');
    const paths = [];
    const swapImages = () => {
      paths.push(paths.shift());

      setTimeout(() => {
        image.classList.add('fadeOut');

        setTimeout(() => {
          image.src = paths[0];
          image.classList.remove('fadeOut');

          swapImages();
        }, 1500);
      }, 3000);
    };

    images.forEach(image => paths.push(image.src));
    paths.sort();
    swapImages();
  }
}
